var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMapRoute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map_black_24dp_1_",
    "data-name": "map_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M0,0H25V25H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M17.583,3l-.133.025L13,4.75,8,3,3.3,4.583a.42.42,0,0,0-.3.4v12.6A.413.413,0,0,0,3.417,18l.133-.025L8,16.25,13,18l4.7-1.583a.42.42,0,0,0,.3-.4V3.417A.413.413,0,0,0,17.583,3ZM8.833,5.058l3.333,1.167v9.717L8.833,14.775Zm-4.167.825,2.5-.842v9.75l-2.5.967Zm11.667,9.233-2.5.842V6.217l2.5-.967Z",
    transform: "translate(2 2)",
    fill: "#25556e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapRoute);
export default __webpack_public_path__ + "static/media/ic_map_route.c19b762477e593acfa93277f5ab878b3.svg";
export { ForwardRef as ReactComponent };